module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_1001359.e8814cf8.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSatF/FormatoSimplificado_1001359.pdf
// module id = 352
// module chunks = 0